import * as yup from "yup";

export const StubSettingsSetupValidationSchema = yup.object().shape({
  // language: yup
  // .number()
  // .required("Language is required"),
  // hoursAndRate: yup
  // .number()
  // .required("Hours and Rate is required"),
  // vactionPayDue: yup
  // .number()
  // .required("Vaction Pay Due is required"),
  // holidayPayDue: yup
  // .number()
  // .required("Holiday Pay Due is required"),
  // companyName: yup
  // .number()
  // .required("Company Name is required"),
  // cashAdvanceDeduction: yup
  // .number()
  // .required("Cash Advance Deduction is required"),
  // emailStub: yup
  // .number()
  // .required("Email Stub is required"),
  // passwordOnEmailStub: yup
  // .number()
  // .required("Password on Email Stub is required"),
  // hourlyRate: yup
  // .number()
  // .required("Hourly Rate is required"),
  // paymentDate: yup
  // .number()
  // .required("Payment Date is required"),
	notes: yup
    .string()
    .max(100, "Maximum length 100 characters"),
});
